import { render, staticRenderFns } from "./IKImage.vue?vue&type=template&id=d9af8ed2&"
import script from "./IKImage.vue?vue&type=script&lang=js&"
export * from "./IKImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports